import { EventToMessage } from "../../ra-lb-tools/components/eventToMessage";
import { debug_log } from "../../ra-lb-tools/utils/debugLog.js";
import { Store } from "../../ra-lb-tools/utils/store";
import { shakeAnimation } from "../../ra-lb-tools/theme/styles";
import { useState } from "react";
import { useNotify } from "react-admin";

const getPressedKey = (e) => {
  const isFromInput = ["INPUT", "TEXTAREA", "SELECT"].includes(
    e.target.tagName
  );
  const isPrintable = e.key.length == 1;

  return !isFromInput && isPrintable ? e.key : undefined;
};

const commands = {
  "debug***": () => {
    console.log("Switching debug mode");
    Store.flip("debug");
    window.location.reload();
  },
};

function endsWithStartOf(str1, str2, minMatch = 0) {
  const minOverlap = Math.min(str1.length, str2.length);

  for (let i = minOverlap; i > minMatch; i--) {
    if (str1.endsWith(str2.slice(0, i))) {
      return str2.slice(0, i);
    }
  }
  return false;
}

function endsWithStartOfAny(haystack, needles, minMatch = 0) {
  for (let index = 0; index < needles.length; index++) {
    const needle = needles[index];
    const intersection = endsWithStartOf(haystack, needle, minMatch);
    if (intersection) {
      return intersection;
    }
  }

  return false;
}

const codeSent = (buffer, callback, notify) => {
  let normalizedBuffer = buffer.toLowerCase();
  const commandList = Object.keys(commands);

  const selectedCommand = commandList.filter((commandKey) =>
    normalizedBuffer.includes(commandKey)
  )[0];

  if (selectedCommand) {
    debug_log(`Execute '${selectedCommand}'`);
    const command = commands[selectedCommand];
    command();
    callback(true);
    return "";
  }

  const partialMatch = endsWithStartOfAny(buffer, commandList, 2);
  if (partialMatch) {
    notify(partialMatch, {
      autoHideDuration: 1800,
      multiLine: true,
      type: "success",
    });
  }

  callback(false);
  return buffer;
};

export const InputMonitor = ({ className, ...props }) => {
  const notify = useNotify();
  const [shake, setShake] = useState(false);
  const classes = shakeAnimation();

  className = [className, "InputMonitor", shake ? classes.shake : null]
    .filter((v) => v)
    .join(" ");

  return (
    <EventToMessage
      className={className}
      tabIndex="0"
      event="onKeyDown"
      eventParser={getPressedKey}
      messageProcessor={(message, callback) =>
        codeSent(message, callback, notify)
      }
      callback={setShake}
      {...props}
    />
  );
};
